
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  introduccion: () => {
    return(
      <>¿Una máquina para el reconocimiento del Covid-19 hecha de manera artesanal por unos estudiantes de colegio? Pues sucedió en la Institución Educativa San José, del municipio de Itagüí, Antioquia, y el equipo líder de este proyecto estuvo conformado por tres estudiantes del grado décimo, quienes tardaron menos de un año para convertir el sueño de una prueba confiable y al alcance de cualquiera, sin importar sus recursos económicos, en una realidad que hoy puede ser compartida para cualquiera que esté interesado en el diseño de una máquina de PCR a bajo costo. </>
    )
  },

  contenido: () => {
    return (
      <div className="lato-300 text-20 text-justify">
        <p className="mb-8">El primer año de pandemia, el 2019, fue el más duro. Hoy, a pesar de las variantes,
pareciera que estuviéramos más preparados para enfrentar un caso por covid-19, pero en los
primeros meses, cuando apenas habían máquinas de PCR en el país para la identificación
del virus, el miedo por ignorar si la repentina tos o fiebre que cualquiera sentía era una
gripa normal o el virus era demasiado grande. Un miedo que se fortalecía por la
incapacidad de encontrar una respuesta a la duda, razón por la que en el municipio de Itagüí
en Antioquia decidimos crear nuestra propia prueba para covid-19. La idea fue diseñar un
termociclador propio que no solo fuera confiable, sino que también fuera tan económico
que cualquiera de nuestros compañeros y personas de la comunidad tuvieran acceso a él sin
preocuparse por el costo. Ese fue nuestro objetivo al iniciar la pandemia y en poco tiempo,
pero después de mucho esfuerzo, lo logramos.</p>

        <p className="mb-8">Sabíamos que el primer paso para enfrentar al virus era identificar a las personas
contagiadas para garantizar su cuidado y aislamiento, y para conseguir esto necesitábamos
una tecnología que no teníamos, pero que diseñamos con material reciclable. Así es, con
materiales que todos podemos conseguir en casa, y con ayuda de nuestros profesores,
elaboramos nuestra propia máquina de PCR que llamamos “C.C.”, que son las siglas de la
lucha que teníamos al frente: <span className="italic">Combating Covid</span>. Empezamos con el diseño, luego hicimos
el prototipo y finalmente logramos cumplir nuestro objetivo: el primer termociclador para
pruebas PCR de bajo costo construido en un colegio.</p>

        <p className="mb-8">Gracias a este proyecto, el primer año de la pandemia dejó de ser una sensación de miedo
absoluto para convertirse en un reto que podíamos enfrentar con esperanza. Ahora teníamos
una tecnología hecha con nuestras propias ideas capaz de identificar oportunamente a las
personas que se contagiaban de covid-19 donde sea que se imagine, porque nuestro
proyecto se compartió por las redes sociales de nuestra institución educativa de manera tan
efectiva que “C.C.” que se ha convertido en una experiencia significativa importante. ¡Sí yo
puedo, tú puedes!, juntos diseñamos el cambio.</p>

       

      
      </div>
    )
  }
}